import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["defaultValue", "value", "placeholder", "onSearch", "disabled", "onChange", "onKeyDown", "onClear", "onBlur", "onFocus", "length", "searchStatus"];
// @ts-nocheck
import * as React from "react";
import { useCallback } from "react";
import classNames from "classnames";
import { useControlled, KEY_VALUES } from "../utils";
var Search = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$defaultValue = props.defaultValue,
    defaultValue = _props$defaultValue === void 0 ? "" : _props$defaultValue,
    valueProp = props.value,
    _props$placeholder = props.placeholder,
    placeholderProp = _props$placeholder === void 0 ? "Search" : _props$placeholder,
    onSearch = props.onSearch,
    disabled = props.disabled,
    onChange = props.onChange,
    onKeyDown = props.onKeyDown,
    onClear = props.onClear,
    onBlur = props.onBlur,
    onFocus = props.onFocus,
    length = props.length,
    searchStatus = props.searchStatus,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  var _useControlled = useControlled(valueProp, defaultValue),
    value = _useControlled[0],
    setValue = _useControlled[1];
  var _React$useState = React.useState(false),
    keyboardFocus = _React$useState[0],
    setKeyboardFocus = _React$useState[1];
  var _React$useState2 = React.useState(false),
    clickFocus = _React$useState2[0],
    setClickFocus = _React$useState2[1];
  var containerRef = React.useRef(null);
  var inputRef = React.useRef(null);
  var placeholder = React.useMemo(function () {
    if (clickFocus || keyboardFocus || value.length > 0) {
      return;
    } else {
      return placeholderProp;
    }
  }, [clickFocus, keyboardFocus, value]);
  var handleClear = function handleClear(event) {
    var _inputRef$current;
    setValue("");
    onChange === null || onChange === void 0 ? void 0 : onChange("", event);
    onClear === null || onClear === void 0 ? void 0 : onClear(event);
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  };
  var handleClearKeyDown = function handleClearKeyDown(event) {
    if (event.key === KEY_VALUES.ENTER) {
      var _inputRef$current2;
      event.preventDefault();
      event.stopPropagation();
      setValue("");
      onChange === null || onChange === void 0 ? void 0 : onChange("", event);
      onClear === null || onClear === void 0 ? void 0 : onClear(event);
      (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.focus();
      setClickFocus(true);
    }
  };
  var showIcon = keyboardFocus || clickFocus || value.length > 0;
  var searchTypeNode = function searchTypeNode() {
    var classes = classNames("ap-search-after-icon", {
      "delete-icon": true,
      showDeleteIcon: showIcon,
      active: value.length > 0
    });
    var searchProps = {
      role: "button",
      type: "button",
      "aria-disabled": disabled || value.length === 0,
      tabIndex: disabled || value.length === 0 ? -1 : 0,
      "aria-label": "clear",
      className: classes,
      onClick: handleClear,
      onKeyDown: handleClearKeyDown
    };
    return /*#__PURE__*/React.createElement("span", searchProps, /*#__PURE__*/React.createElement("i", {
      className: "Appkit4-icon icon-circle-delete-outline",
      "aria-hidden": true
    }));
  };
  var handleClick = function handleClick(event) {
    var _inputRef$current3;
    (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.focus();
    setClickFocus(true);
    setKeyboardFocus(false);
  };
  var onkeydown = function onkeydown(event) {
    if (event.key === KEY_VALUES.TAB) {
      setClickFocus(true);
      setKeyboardFocus(true);
      if (event.target !== inputRef.current) {
        setClickFocus(false);
        return;
      }
    }
  };
  var handleChange = function handleChange(event) {
    var value = event.target.value;
    setValue(value);
    onChange === null || onChange === void 0 ? void 0 : onChange(value, event);
  };
  var handleInputBlur = useCallback(function (event) {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    setClickFocus(false);
    setKeyboardFocus(false);
  }, [onBlur]);
  var handleInputFocus = useCallback(function (event) {
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
  }, [onFocus]);
  var handleInputKeyDown = function handleInputKeyDown(event) {
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "ap-search-container",
    ref: containerRef,
    onKeyUp: onkeydown
    // tabIndex={-1}
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    "aria-live": "assertive",
    "aria-atomic": true,
    className: "search-result"
  }, searchStatus), /*#__PURE__*/React.createElement("div", {
    className: classNames("ap-search-input", {
      "keyboard-focus": keyboardFocus,
      focus: clickFocus
    }),
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    type: "text",
    className: "ap-field-input",
    tabIndex: 0,
    value: value,
    placeholder: placeholder,
    onChange: handleChange,
    role: "searchbox",
    autoComplete: "off",
    "aria-disabled": disabled,
    "aria-label": "dropdown search box",
    "aria-activedescendant": "",
    disabled: disabled,
    onKeyDown: handleInputKeyDown,
    onFocus: handleInputFocus,
    onBlur: handleInputBlur
  }), /*#__PURE__*/React.createElement("i", {
    className: classNames("Appkit4-icon icon-search-outline", {
      activeSearch: value.length > 0
    }),
    "aria-hidden": true
  }), searchTypeNode()));
});
export default Search;